export default __webpack_public_path__ + "55edc7930c46cfbb9efa8cd457157816.png";